import { render } from "./customTable.vue?vue&type=template&id=2737e33e"
import script from "./customTable.vue?vue&type=script&lang=js"
export * from "./customTable.vue?vue&type=script&lang=js"

import "./customTable.vue?vue&type=style&index=0&id=2737e33e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__